import StatusFlagCell from '../StatusFlagCell';
import JobCellRenderer from './JobNoCellRenderer';
import CustomerLaneCellRenderer from '../CustomerLaneCellRenderer';
import ReasonCodeCellRenderer, {
  ReasonCodePickerRenderer,
} from '../ReasonCodeCellRenderer';
import OnTargetCellRenderer from '../OnTargetCellRenderer';
import ContractOnTargetCellRenderer from '../ContractOnTargetCellRenderer';
import ProgressCellRenderer from '../ProgressCellRenderer';
import ContractProgressCellRenderer from '../ContractProgressCell';
import CustomerWithHoverMenuRenderer from '../CustomerWithHoverMenuRenderer';
import CurrencyCell from '../CurrencyCell';
import PercentageCell from '../PercentageCell';
import NumberCell from '../NumberCell';
import DateCell from '../DateCell';
import DrillDownCell from '../DrillDownCell';
import MetricHeaderCell from '../MetricHeaderCell';
import SalesCommissionCell from './SalesCommissionCell';
import { BULK_SALES_COMM_CELL } from '../../hooks/useColumnDefs';
import BulkSalesCommissionCell from './BulkSalesCommissionCell';
import GroupingCellRenderer from '../V5Gadget/Matrix/GroupingCellRenderer';
import { HISTOGRAM_CELL_RENDERER } from '../SingleMetricDateMatrix/SingleMetricDateMatrixContent/constants';
import HistogramCellRenderer from '../SingleMetricDateMatrix/SingleMetricDateMatrixContent/HistogramCellRenderer';
import {
  KpiNameRenderer,
  TrendCellRenderer,
} from '../../screens/GoalShow/GoalKpiVis/cellRenderers';
import {
  KPI_NAME_RENDERER,
  TREND_CELL_RENDERER,
} from '../../screens/GoalShow/GoalKpiVis/constants';
import NormalCellRenderer from '../V5Gadget/Matrix/NormalCellRenderer';
import PerformanceEntityCell from '../PerformanceBoards/PerformanceEntityCell';
import {
  PERFORMANCE_ENTITY_CELL,
  PERFORMANCE_STATUS_CELL,
} from '../PerformanceBoards/constants';
import GeoPointCell from '../GeoPointCell';
import EntityCell from './EntityCell';
import {
  BOOLEAN_ICON_CELL,
  BONUS_SCORE_CELL,
  COLOUR_CODED_NUMBER_CELL,
  DATE_CELL,
  DRILL_DOWN_CELL,
  ENTITY_CELL,
  GEO_POINT_CELL,
  NUMBER_CELL,
  BONUS_EXPECTATION_CELL,
  BONUS_REWARD_CELL,
  BONUS_STATUS_CELL,
  BONUS_QUALIFIED_CELL,
} from './constants';
import DriverCell from 'components/DriverBonusLegacy/DriverCell';
import { PACE_CELLS } from '../PaceMatrix/PaceMatrixContent/constants';
import PaceDiffCell from '../PaceMatrix/PaceMatrixContent/PaceDiffCell';
import PaceCell from '../PaceMatrix/PaceMatrixContent/PaceCell';
import PerformanceStatusCell from '../PerformanceBoards/PerformanceBoard/Grid/PerformanceStatusCell';
import BonusStatusCell from '../DriverAX/components/BonusStatusCell';
import BonusExpectationCell from '../DriverAX/components/BonusExpectationCell';
import BonusRewardCell from '../DriverAX/components/BonusRewardCell';
import BonusQualifiedCell from '../DriverAX/components/BonusQualifiedCell';
import BonusScoreCell from '../DriverAX/components/BonusScoreCell';
import ColourCodedNumberCell from '../ColourCodedNumberCell';
import BooleanIconCell from '../BooleanIconCell';

import SelectDocumentCell, {
  SELECT_DOCUMENT_CELL,
  SELECT_DOCUMENT_HEADER_CELL,
  SelectDocumentHeaderCell,
} from './SelectDocumentCell';
import BadgeCell, { BADGE_CELL } from './BadgeCell';
import BonusTagPillCell, {
  BONUS_TAG_PILL_CELL,
} from '../DriverAX/components/BonusRecordTagging/BonusTagPillCell';
import SmsStatusCell, {
  SMS_STATUS_CELL,
} from '../DriverAX/screens/DriverSetupAndAppAccess/components/SmsStatusCell';
import DeltaHeaderCell, { DELTA_HEADER_CELL } from './DeltaHeaderCell';

const GridFrameworkComponents = {
  statusFlagCell: StatusFlagCell,
  driverCell: DriverCell,
  jobCell: JobCellRenderer,
  laneCell: CustomerLaneCellRenderer,
  reasonCodeCell: ReasonCodeCellRenderer,
  reasonCodePicker: ReasonCodePickerRenderer,
  onTargetCell: OnTargetCellRenderer,
  contractOnTargetCell: ContractOnTargetCellRenderer,
  progressCell: ProgressCellRenderer,
  contractProgressCell: ContractProgressCellRenderer,
  customerWithHoverMenuCell: CustomerWithHoverMenuRenderer,
  currencyCell: CurrencyCell,
  percentageCell: PercentageCell,
  [NUMBER_CELL]: NumberCell,
  [DATE_CELL]: DateCell,
  [DRILL_DOWN_CELL]: DrillDownCell,
  metricHeaderCell: MetricHeaderCell,
  salesCommissionCell: SalesCommissionCell,
  [BULK_SALES_COMM_CELL]: BulkSalesCommissionCell,
  groupingCellRenderer: GroupingCellRenderer,
  [HISTOGRAM_CELL_RENDERER]: HistogramCellRenderer,
  [TREND_CELL_RENDERER]: TrendCellRenderer,
  [KPI_NAME_RENDERER]: KpiNameRenderer,
  [PERFORMANCE_ENTITY_CELL]: PerformanceEntityCell,
  normalCellRenderer: NormalCellRenderer,
  [GEO_POINT_CELL]: GeoPointCell,
  [ENTITY_CELL]: EntityCell,
  [PACE_CELLS.DIFF]: PaceDiffCell,
  [PACE_CELLS.CELL]: PaceCell,
  [PERFORMANCE_STATUS_CELL]: PerformanceStatusCell,
  [BONUS_STATUS_CELL]: BonusStatusCell,
  [BONUS_EXPECTATION_CELL]: BonusExpectationCell,
  [BONUS_QUALIFIED_CELL]: BonusQualifiedCell,
  [BONUS_REWARD_CELL]: BonusRewardCell,
  [BONUS_SCORE_CELL]: BonusScoreCell,
  [COLOUR_CODED_NUMBER_CELL]: ColourCodedNumberCell,
  [BOOLEAN_ICON_CELL]: BooleanIconCell,
  [SELECT_DOCUMENT_CELL]: SelectDocumentCell,
  [SELECT_DOCUMENT_HEADER_CELL]: SelectDocumentHeaderCell,
  [BADGE_CELL]: BadgeCell,
  [BONUS_TAG_PILL_CELL]: BonusTagPillCell,
  [SMS_STATUS_CELL]: SmsStatusCell,
  [DELTA_HEADER_CELL]: DeltaHeaderCell,
};

export default GridFrameworkComponents;
